import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-html-css',
  templateUrl: './html-css.component.html',
  styleUrls: ['./html-css.component.scss'],
})
export class HtmlCssComponent implements OnInit {
  modulesText = {
    text: 'Lo strumento utilizzato durante il corso è un semplice editor HTML attraverso il quale gli studenti potranno vedere quello che fanno e capire la costruzione della pagina grazie al codice a vista.',
  };

  constructor() {}

  ngOnInit(): void {}
}
